import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";
import { forkJoin } from "rxjs";
import { finalize, map } from "rxjs/operators";
import { sampleDeploysWithErrors } from "../../deploys-with-errors/sample-deploys-with-errors";
import { DeployService } from "../../models/deploy.service";
import { StatsmanService } from "../../models/statsman.service";
import { TimeDurAgoService } from "../../time-dur-ago/time-dur-ago.service";
import { timeSample } from "../../utils/time-sample";

@Component({
  selector: "ab-deploy-column",
  templateUrl: "./deploy-column.component.html",
})
export class DeployColumnComponent implements OnChanges {
  @Input() public dur: string;
  @Input() public featureDisabled: boolean;
  @Input() public lastN: string | number;
  @Input() public project: any;
  @Output() public loadingChanged = new EventEmitter<number>();

  public deployData: any;
  public loading: boolean;
  public statData: any;

  constructor(
    private deployService: DeployService,
    private statsmanService: StatsmanService,
    private timeDurAgoService: TimeDurAgoService,
  ) {}

  public ngOnChanges() {
    if (this.featureDisabled == null) {
      return;
    }
    if (this.featureDisabled !== false) {
      this.generateSampleData();
      return;
    }
    if (this.project == null || this.dur == null || this.lastN == null) {
      return;
    }

    this.loading = true;
    this.loadingChanged.emit(1);

    forkJoin([this.goabQuery(), this.statsmanQuery()])
      .pipe(
        finalize(() => {
          this.loading = false;
          this.loadingChanged.emit(-1);
        }),
      )
      .subscribe(([deployData, statData]: any[]) => {
        this.deployData = deployData;
        this.statData = statData;
      });
  }

  private goabQuery() {
    return this.deployService.query({
      projectId: this.project.id,
      group_created_count__gte: 1,
      created_at__gte: this.timeDurAgoService.timeFor(this.dur, this.lastN),
    });
  }

  private statsmanQuery() {
    const statsmanParams = {
      dur: this.dur,
      last_n: this.lastN,
      name: [`projects.${this.project.id}.deploys`],
      projectId: this.project.id,
      type: "counter",
    };

    return this.statsmanService
      .query(statsmanParams)
      .pipe(map((data: any) => data[`projects.${this.project.id}.deploys`]));
  }

  private generateSampleData() {
    this.statData = {
      count: Array.from(Array(90), () => Math.round(Math.random() * 10)),
      time: timeSample(),
    };
    this.deployData = sampleDeploysWithErrors;
  }
}
